export const UI_PREF_PREFIX = 'ui_pref:';

export function getUiPreference<T>(key: string, fallback: T): T {
  if (typeof window === 'undefined') return fallback;
  try {
    const raw = window.localStorage.getItem(UI_PREF_PREFIX + key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function setUiPreference<T>(key: string, value: T): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(UI_PREF_PREFIX + key, JSON.stringify(value));
  } catch {
    // storage unavailable / quota exceeded — silently ignore
  }
}

export function clearAllUiPreferences(): number {
  if (typeof window === 'undefined') return 0;
  let cleared = 0;
  try {
    const toRemove: string[] = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith(UI_PREF_PREFIX)) {
        toRemove.push(key);
      }
    }
    for (const key of toRemove) {
      window.localStorage.removeItem(key);
      cleared++;
    }
    window.dispatchEvent(new CustomEvent('ui-preferences-reset'));
  } catch {
    // ignore
  }
  return cleared;
}
